import { LoadingOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import React from 'react';
import NumberFormat from 'react-number-format';

import { filterOption, moneyConfig, tonConfig } from '../../../../helpers/form';
import {
  formatarCnpjCpfIMask,
  removeMoedaMask,
} from '../../../../helpers/formatador';
import { getPagadores } from '../../../../helpers/pagadores';
import apiATS from '../../../../services/apiATS';
import apiNetCore from '../../../../services/apiNetCore';
import { calculaFretes, getDadosCalculo } from './calculos';

export const numberElement = (record, dataIndex, form, save, inputRef) => {
  let propsInput;

  const calculaFretesAndSave = async event => {
    const valor = removeMoedaMask(event.target.value) || 0;

    if (valor !== record[dataIndex]) {
      await calculaFretes(event.target.value, dataIndex, record);

      if (dataIndex === 'freteMotoristaPj') {
        form.setFieldsValue({
          freteTotalPj: record.freteTotalPj,
        });
      } else if (dataIndex === 'freteTotalPj') {
        form.setFieldsValue({
          freteMotoristaPj: record.freteMotoristaPj,
        });
      } else if (dataIndex === 'freteMotoristaPf') {
        form.setFieldsValue({
          freteTotalPf: record.freteTotalPf,
        });
      } else if (dataIndex === 'freteTotalPf') {
        form.setFieldsValue({
          freteMotoristaPf: record.freteMotoristaPf,
        });
      }
    }

    save();
  };

  if (dataIndex.includes('frete')) {
    propsInput = {
      ...moneyConfig,
      className: 'total-width',
      onFocus: () => getDadosCalculo(record),
      value: record[dataIndex],
      onBlur: calculaFretesAndSave,
      onPressEnter: calculaFretesAndSave,
      customInput: props => <Input ref={inputRef} {...props} />,
    };
  } else {
    propsInput = {
      ...tonConfig,
      customInput: props => <Input ref={inputRef} {...props} />,
      className: 'total-width',
      onPressEnter: save,
      onBlur: save,
      value: record[dataIndex],
      ...(dataIndex === 'cadencia' && {
        isAllowed: values => values.floatValue >= 0,
      }),
    };
  }

  return <NumberFormat {...propsInput} />;
};

export const selectElement = (
  user,
  form,
  record,
  inputRef,
  save,
  dataIndex,
  tipoCliente,
  loadingData,
  setLoadingData,
  searchCidades,
  onSearchCidades,
  onSearchProdutos,
  onSearchClientes,
  required
) => {
  const initialValue = record[dataIndex];
  let propsSelect = {
    ref: inputRef,
    onBlur: save,
    value: initialValue,
    notFoundContent: loadingData ? <LoadingOutlined /> : null,
    loading: loadingData,
  };
  let childrenSelect = '';

  const getProdutosCliente = async (cnpjClientePagador = '') => {
    const {
      data: { produtoEspecie },
    } = await apiNetCore.get('ApiMaxicon/clifor/getProdutoEspecie', {
      params: {
        cpf: cnpjClientePagador || record.cnpjClientePagador,
      },
    });
    const especies = produtoEspecie.filter(
      (produto, index, produtosEspecies) =>
        produtosEspecies.findIndex(
          especie => especie.codigoEspecie === produto.codigoEspecie
        ) === index
    );

    record.clienteTemProduto = false;
    record.dataProdutos = produtoEspecie;

    if (produtoEspecie.length) {
      record.clienteTemProduto = true;
      record.dataProdutos = produtoEspecie;
      record.dataEspecies = especies;
    }

    return produtoEspecie.length;
  };

  const getEspecies = async () => {
    const { data } = await apiATS.post('/EspecieAts/ConsultarGrid', {
      Page: 1,
      Take: 100,
      Order: { Campo: 'Descricao', Operador: 0 },
    });

    const especies = data.data.items.map(({ IdEspecie, Descricao }) => ({
      codigoEspecie: IdEspecie,
      descricaoEspecie: Descricao,
    }));
    record.dataEspecies = especies;
  };

  const recalculaFrete = async () => {
    setLoadingData(true);
    if (record.freteInserido) {
      const tipoFrete = record.freteInserido;
      const valor = record[tipoFrete];
      await getDadosCalculo(record);
      calculaFretes(valor, tipoFrete, record);
    }
    setLoadingData(false);
  };

  const setProdutoEspecie = (idProduto, produto, idEspecie, especie) => {
    record.idProduto = idProduto;
    record.produto = produto;
    record.idEspecie = idEspecie;
    record.especie = especie;

    form.setFieldsValue({
      produto,
      especie,
    });
  };

  const setDadoCidade = ({
    cidadeAtual,
    temEndereco = false,
    cidades = null,
    idCidade = null,
    idEstado = null,
    idClienteEndereco = null,
    cidadeUf = null,
    cidadeUfForm = null,
  }) => {
    record[`${cidadeAtual}TemEndereco`] = temEndereco;
    record[`${cidadeAtual}Data`] = cidades;
    record[`idCidade${tipoCliente}`] = idCidade;
    record[`idEstado${tipoCliente}`] = idEstado;
    record[`idClienteEndereco${tipoCliente}`] = idClienteEndereco;
    record[cidadeAtual] = cidadeUf;
    form.setFieldsValue({
      [`${cidadeAtual}`]: cidadeUfForm,
    });
  };

  const onFocusPagadores = async () => {
    if (record.dataPagadores) return;
    setLoadingData(true);

    const pagadores = await getPagadores(user);
    record.dataPagadores = pagadores;

    setLoadingData(false);
  };

  const onFocusProdutos = async () => {
    if (record.dataProdutos) return;
    setLoadingData(true);

    await getProdutosCliente();

    setLoadingData(false);
  };

  const onFocusCidade = async value => {
    if (!value || value.includes('-')) return;
    await searchCidades(value);
  };

  const onfocusEspecies = async () => {
    if (record.dataEspecies) return;
    setLoadingData(true);

    await getEspecies();

    setLoadingData(false);
  };

  const onSelectPagador = async (cnpj, item) => {
    setLoadingData(true);

    record.idClientePagador = item.idclientepagador;
    record.idClienteRaiz = item.idclienteraiz;

    if (await getProdutosCliente(cnpj)) {
      setProdutoEspecie(
        record.dataProdutos[0].codigoProduto,
        record.dataProdutos[0].descricaoProduto,
        record.dataProdutos[0].codigoEspecie,
        record.dataProdutos[0].descricaoEspecie
      );
    } else {
      await getEspecies();
    }

    await recalculaFrete();
    setLoadingData(false);
  };

  const onSelectProduto = (_, item) => {
    const especie = record.dataProdutos.find(
      produto => `${produto.codigoProduto}${produto.codigoEspecie}` === item.key
    );

    setProdutoEspecie(
      item.codigoproduto,
      item.descricaoproduto,
      especie.codigoEspecie,
      especie.descricaoEspecie
    );
    save();
  };

  const onSelectEspecie = (_, item) => {
    record.idEspecie = item.idespecie;
    save();
  };

  const onSelectPedagioIncluso = async value => {
    record.pedagioIncluso = value;
    await recalculaFrete();
  };

  const onSelectCliente = async (value, item) => {
    if (!value) return;
    setLoadingData(true);

    const cidadeAtual = `cidade${tipoCliente}`;
    const { clienteEndereco } = record[`dataCliente${tipoCliente}`].find(
      cliente => cliente.idCliente === Number(item.key)
    );

    record[`cnpjCliente${tipoCliente}`] = item.cnpjcliente;
    record[`idCliente${tipoCliente}`] = Number(item.key);

    const cidades = clienteEndereco.filter(
      (cliente, index, clienteEnderecos) =>
        clienteEnderecos.findIndex(
          endereco => endereco.endereco === cliente.endereco
        ) === index
    );

    if (cidades.length) {
      const { idCidade, cidade, idEstado, uf, idClienteEndereco } = cidades[0];
      setDadoCidade({
        cidadeAtual,
        cidades,
        idCidade,
        idEstado,
        idClienteEndereco,
        temEndereco: true,
        cidadeUf: `${cidade} - ${uf}`,
        cidadeUfForm: `${cidade} - ${uf}`,
      });
    } else {
      setDadoCidade({ cidadeAtual });
    }

    await recalculaFrete();
    setLoadingData(false);
  };

  const onSelectCidade = async (_, item) => {
    setLoadingData(true);
    record[`idCidade${tipoCliente}`] = item.idcidade || null;
    record[`idEstado${tipoCliente}`] = item.idestado || null;
    record[`idClienteEndereco${tipoCliente}`] = item.idclienteendereco || null;
    record[dataIndex] = item.cidade;
    form.setFieldsValue({
      [dataIndex]: item.cidade,
    });

    await recalculaFrete();
    setLoadingData(false);
    save();
  };

  const onClearCliente = async () => {
    const cidadeAtual = `cidade${tipoCliente}`;
    setDadoCidade({ cidadeAtual });
    await recalculaFrete();
  };

  const onClearCidade = async () => {
    record[`idCidade${tipoCliente}`] = null;
    await recalculaFrete();
  };

  const tipoPedagio = [
    {
      nome: 'SIM',
    },
    {
      nome: 'NÃO',
    },
  ];

  switch (true) {
    case dataIndex === 'cnpjClientePagador':
      propsSelect = {
        ...propsSelect,
        onFocus: onFocusPagadores,
        onSelect: onSelectPagador,
      };
      childrenSelect =
        record.dataPagadores &&
        record.dataPagadores.map(data => (
          <Select.Option
            key={data.id}
            value={data.cnpj}
            idclientepagador={data.id}
            idclienteraiz={data.id_cliente_raiz}
          >
            {formatarCnpjCpfIMask(data.cnpj)}
          </Select.Option>
        ));
      break;
    case dataIndex === 'produto':
      propsSelect = {
        ...propsSelect,
        showSearch: !record.clienteTemProduto,
        onSearch: !record.clienteTemProduto && onSearchProdutos,
        onSelect: record.clienteTemProduto && onSelectProduto,
        onFocus: onFocusProdutos,
      };
      childrenSelect =
        record.dataProdutos &&
        record.dataProdutos.map(data => (
          <Select.Option
            key={
              record.clienteTemProduto
                ? `${data.codigoProduto}${data.codigoEspecie}`
                : data.codigoProduto
            }
            value={
              record.clienteTemProduto
                ? `${data.descricaoProduto} - ${data.descricaoEspecie}`
                : data.descricaoProduto
            }
            descricaoproduto={data.descricaoProduto}
            codigoproduto={data.codigoProduto}
          >
            {data.descricaoProduto}
            <br />
            {data.descricaoEspecie || null}
          </Select.Option>
        ));
      break;
    case dataIndex === 'especie':
      propsSelect = {
        ...propsSelect,
        showSearch: !record.clienteTemProduto,
        onFocus: !record.clienteTemProduto && onfocusEspecies,
        onSelect: onSelectEspecie,
        filterOption: (input, { title: titleOption }) =>
          filterOption(input, titleOption, 0),
      };
      childrenSelect =
        record.dataEspecies &&
        record.dataEspecies.map(data => (
          <Select.Option
            value={data.descricaoEspecie}
            key={data.codigoEspecie}
            title={data.descricaoEspecie}
            idespecie={data.codigoEspecie}
          >
            {data.descricaoEspecie}
          </Select.Option>
        ));
      break;
    case dataIndex.includes('cliente'):
      propsSelect = {
        ...propsSelect,
        allowClear: !required,
        showSearch: true,
        filterOption: false,
        showAction: ['click'],
        onSearch: onSearchClientes,
        onSelect: onSelectCliente,
        onClear: onClearCliente,
      };
      childrenSelect =
        record[`dataCliente${tipoCliente}`] &&
        record[`dataCliente${tipoCliente}`].map(dado => (
          <Select.Option
            key={dado.idCliente}
            cnpjcliente={dado.cnpj}
            value={`${dado.razaoSocial} - ${formatarCnpjCpfIMask(dado.cnpj)}`}
          >
            {dado.razaoSocial}
            <br />
            {formatarCnpjCpfIMask(dado.cnpj)}
          </Select.Option>
        ));
      break;
    case dataIndex.includes('cidade'):
      propsSelect = {
        ...propsSelect,
        allowClear: !required,
        showSearch: !record[`${dataIndex}TemEndereco`],
        filterOption: false,
        showAction: ['click'],
        onSearch: !record[`${dataIndex}TemEndereco`] && onSearchCidades,
        onSelect: onSelectCidade,
        onClear: onClearCidade,
        onFocus: () => onFocusCidade(initialValue),
        open: true,
      };

      childrenSelect =
        record[`${dataIndex}Data`] &&
        record[`${dataIndex}Data`].map(dado => (
          <Select.Option
            key={
              record[`${dataIndex}TemEndereco`]
                ? dado.idClienteEndereco
                : dado.idCidade
            }
            cidade={`${dado.cidade} - ${dado.uf}`}
            idestado={dado.idEstado}
            idcidade={dado.idCidade}
            idclienteendereco={dado.idClienteEndereco || null}
          >
            {`${dado.cidade} - ${dado.uf}`}
            <br />
            {dado.endereco || null}
          </Select.Option>
        ));
      break;
    case dataIndex === 'pedagioIncluso':
      propsSelect = {
        ...propsSelect,
        onSelect: onSelectPedagioIncluso,
      };
      childrenSelect = tipoPedagio.map(data => (
        <Select.Option value={data.nome} key={data.nome}>
          {data.nome}
        </Select.Option>
      ));
      break;
    default:
      childrenSelect = <Select.Option> </Select.Option>;
  }

  return <Select {...propsSelect}>{childrenSelect}</Select>;
};
